<script lang="ts" setup>
import { type PropType, computed } from '#imports';
import { dayGap, formatDate } from '~/utils/utility';

const props = defineProps({
  data: {
    type: Object as PropType<any>,
    default: () => ({}),
  },
});

const days = computed(() => {
  const now = new Date().getTime();
  if (now < props.data.startTime) {
    return dayGap(now, props.data.startTime);
  } else {
    return 0;
  }
});
</script>

<template>
  <div>
    <div class="flex h-[123px] flex-col items-center justify-center">
      <div class="text-sm font-bold leading-[22px] text-colorText">
        <span>距</span>
        <span
          class="relative mx-1 after:absolute after:bottom-0 after:left-0 after:h-[5px] after:w-full after:bg-primary/30"
          >{{ data.title }}</span
        >
        <span>还有</span>
      </div>
      <div class="mb-2 mt-3 flex items-end justify-center">
        <div class="text-[30px] leading-none text-colorText font-[DIN]">
          {{ days }}
        </div>
        <div class="ml-1 text-sm leading-[22px] text-colorTextTertiary">
          天
        </div>
      </div>
      <div class="text-xs leading-5 text-colorTextTertiary">
        <span>{{ formatDate(data.startTime, 'MM月DD日') }}</span>
        <span>开始</span>
      </div>
    </div>
  </div>
</template>
